<template>
  <div>
    <el-form :model="self_form" ref="companyFrom" label-position="right" label-width="120px" :rules="rules">
      <el-form-item label="公司名称：" prop="companyName">
        <el-input width="50%" v-model="self_form.companyName"></el-input>
      </el-form-item>
      <el-form-item label="联系方式：" prop="phone">
        <span>手机 {{self_form.phone || '-'}} </span>
        <el-divider direction="vertical"></el-divider>
        <span>weixin {{self_form.wx || '-'}} </span>
        <el-button type="link" @click="handleEdit()">修改</el-button>
      </el-form-item>
      <el-form-item label="主营类目：" :rules="categoryRules" prop="majorCategory">
        <div class="main-categories">
          <el-tag v-for="(tag, index) in categoryOptions" :key="tag.id" @close="delMainCategory('single',index)" class="mar-r" type="info" closable>{{tag.name}}</el-tag>
        </div>
        <el-button type="link" @click="editMainCategory">设置主营类目</el-button>
        <el-button type="link" @click="delMainCategory('clear')">清空</el-button>
      </el-form-item>
      <el-form-item label="主营平台/店铺数：">
        <div class="main-platform">
          <div class="mr-20 show-box">
            <el-checkbox v-model="self_form.showMainPlatform" :true-label="1" :false-label="0">{{ isDistributorMyCard ? '供销商' : '分销商' }}可见</el-checkbox>
            <el-tooltip :content="showMainPlatformTips" placement="top" effect="dark">
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
          </div>
          <div class="platform-item" v-for="item in self_form.majorPlatform" :key="item.k">
            <el-avatar size="small" :src="PLATFORM_ICONS_MAP[item.k]"></el-avatar>
            <span class="num">{{item.v}}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="商家简介：" prop="summary">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          maxlength="500"
          show-word-limit
          width="80%"
          v-model="self_form.summary">
        </el-input>
      </el-form-item>
      <el-form-item label="商家实力视频：" prop="video">
        <!-- <MutilVideoUpload
            v-model="self_form.video"
            :limitSize="500"
        /> -->
        <VideoUpload
          style="display:inline-block;"
          :video="actualVideo ? actualVideo[0] : null"
          :limitSize="500"
          :isSingle="true"
          @upload-success="videoSuccess"
          @del="videoDel"
        />
        <div class="tips ft-12">
          <span>限上传1个视频，视频格式仅支持MP4，视频大小不超过500M,建议视频比例为4:3</span>
        </div>
      </el-form-item>
      <el-form-item label="商家实力图：" prop="picture">
        <MutiImgUpload
            v-model="self_form.picture"
            ref="picture"
            :mainImgNums="0"
            :limitNums="9"
            :limitSize="2 * 1024 * 1024"
            limitSuffix=".jpg,.jpeg,.png" />
        <div class="tips ft-12">
          <span>支持批量上传图片，最多上传9张。图片格式支持jpg/png，建议图片比例为4:3，单张图片大小不超过2M</span>
        </div>
      </el-form-item>
      <el-form-item label="退货地址：" prop="receiveAddressId" v-if="identity === 'supplier'">
          <el-button type="link" @click="openEditRefundAddress">编辑退货地址</el-button>
          <div>
            <!-- <el-input v-model="self_form.companyName" width="80%"></el-input> -->
              <el-select v-model="self_form.receiveAddressId" placeholder="请选择地址" width="80%">
                <el-option
                  v-for="item in addressList"
                  :key="item.id"
                  :label="`${item.receiveName || ''} ${item.phone || ''} ${item.province}${item.city}${item.district}${item.detailAddress}`"
                  :value="item.id">
                </el-option>
              </el-select>
          </div>
      </el-form-item>
      <el-form-item label="合作说明：" prop="summary" v-if="identity === 'supplier'">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入合作说明，可用于描述分销注意事项，截单说明，售后说明等"
          maxlength="500"
          show-word-limit
          width="80%"
          v-model="self_form.collaborationDesc">
        </el-input>
      </el-form-item>
  </el-form>
  <ContactOverviewDialog ref="contactOverview" @edit="editPhone"/>
  <EditMainCategoryDialog ref="editMainCategoryDialog" />
  <EditRefundAddress ref="editRefundAddressDialog" />
  </div>
</template>

<script>
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import ContactOverviewDialog from "./ContactOverviewDialog.vue";
import EditRefundAddress from './EditRefundAddress.vue';
import MutilVideoUpload from "@/components/Uploads/MutilvideoUpload.vue";
// import VideoUpload from "@/components/Uploads/video.vue"
import VideoUpload from '@/components/Uploads/videoUpload'
import EditMainCategoryDialog from '@/components/prod/center/dialogs/EditMainCategoryDialog.vue'
import {getMainCategoryList, setMainCategoryList, getCategoryOptions} from '@/servers/prod/center'
import { queryAddress } from "@api/distributor";
import { PLATFORM_ICONS_MAP } from '@/dictionary/platforms.js'

export default {
  props: {
    editCompanyForm: {
      type: Object,
      default: () => {
        return {
          companyName: '',
          majorCategory: '',
          wx: '',
          phone: '',
          vipMark: false,
          distributionPlatform: [],
          majorPlatform: [],
          picture: [],
          summary: '',
          showDistributor: 1,
          showSupplier: 1,
          collaborationDesc:'',
          receiveAddressId:null,
        }
      }
    },
    identity: {
      type: String,
      default: 'supplier'
    },
  },
  data() {
    let categoryValid = (rule, value, callback) => {
      if(!this.categoryOptions.length){
        return callback(new Error('主营类目不能为空'))
      }
      callback();
    }
    let phoneValid = (rule, value, callback) => {
      if(!this.self_form.phone) {
        return callback(new Error('联系人手机不能为空'))
      }
      callback();
    }
    let pictureValid = async (rule, value, callback) => {
      const errMsg = await this.$refs.picture.method_validImage();
      if(errMsg) {
        callback(new Error(errMsg))
      } else {
        callback()
      }
    }
    return {
       self_form: {
          companyName: '',
          majorCategory: [],
          wx: '',
          phone: '',
          vipMark: false,
          distributionPlatform: [],
          majorPlatform: [],
          showMainPlatform: 1,
          collaborationDesc:'',
          receiveAddressId:null,
      },
       addressList:[],
       mainCategoryList: [],
       PLATFORM_ICONS_MAP,
       rules:{
         companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur'}],
         phone: [{ required: true, validator: phoneValid, trigger: 'change'}],
         picture: [{validator:pictureValid, trigger: 'change'}]
       },
       categoryRules:{ required: true, validator: categoryValid},
       actualVideo: [],
       categoryOptions: [],
       isClear: false
    }
  },
  computed: {
    // categoryOptions: {
    //   get() {
    //     return this.$store.getters.baseCascaderCategory
    //   }
    // }
    isDistributorMyCard() {
      // 分销商名片
      return this.identity === 'myDistributor';
    },
    showMainPlatformTips() {
      return this.isDistributorMyCard ? '默认勾选，勾选之后供销商可以看到你的主营平台信息' : '默认勾选，勾选之后分销商可以看到你的主营平台和分销平台信息';
    },
  },
  created() {
    // 获取已设置主营类目
    this.fetch_getMainCategoryList();
    // this.fetch_getCategoryOptions();
    // 获取设置主营类目列表
    this.$store.dispatch("getBaseCategoryTopAnd1");

  },
  watch: {

    categoryOptions: {
      handler(v) {
        this.self_form.majorCategory = [...v]
      },
      deep: true,
      immediate: true
    },
    editCompanyForm: {
      handler(v){
        let formData = {
          ...v,
          showMainPlatform: this.isDistributorMyCard ? v.showSupplier : v.showDistributor,
        }
        this.$set(this, 'self_form' , formData)
        this.$set(this, 'actualVideo', v.video)
        this.fetch_getCategoryOptions()
        this.getAddressList();
      },
      deep: true,
      immediate: true
    }
  }, 
  components: {
    MutiImgUpload,
    VideoUpload,
    ContactOverviewDialog,
    MutilVideoUpload,
    EditMainCategoryDialog,
    EditRefundAddress,
  },
  methods: {
    async fetch_getCategoryOptions() {
      const options = await getCategoryOptions();
      this.categoryOptions = options && options.length ? options : [];
    },
    videoSuccess(video) {
      this.actualVideo = [video];
    },
    videoDel() {
      this.actualVideo = null;
    },
    editPhone(contactData) {
      if (contactData.phone !== undefined) this.self_form.phone = contactData.phone;
      if (contactData.wx !== undefined) this.self_form.wx = contactData.wx;
      if (contactData.wxCode !== undefined) this.self_form.wxCode = contactData.wxCode;
      this.$refs.companyFrom.clearValidate('phone');
      this.$emit('contact-updated', contactData);
    },
    async delMainCategory(type,index) {
      if(type == 'single') {
        const list = [...this.categoryOptions]
        if(list.length === 1) return this.$message.error('主营类目为必填项，不能删除')
        list.splice(index, 1);
        const categoryOptions = await setMainCategoryList(list);
         this.$message.success('删除成功');
      // this.$store.dispatch("getCategory");
        this.fetch_getCategoryOptions();
        this.fetch_getMainCategoryList();
      } else {
        this.categoryOptions = [];
        this.isClear = true;
        this.$emit('clear', this.isClear);
        // const categoryOptions = await setMainCategoryList([]);
      }
    },
    handleEdit() {
      this.$refs.contactOverview.method_open(
        this.self_form.companyName,
        this.self_form.phone,
        this.self_form.wx,
        this.self_form.wxCode
      )
    },
    async fetch_getMainCategoryList() {
      const res = await getMainCategoryList();
      if(!res) return;
      this.mainCategoryList = res;
    },
    editMainCategory() {
      this.$refs.editMainCategoryDialog.method_open(this.mainCategoryList, (mainList) => {
        // this.$store.dispatch("getCategory")
        this.fetch_getCategoryOptions()
        this.fetch_getMainCategoryList()
        this.isClear = false;
        this.$emit('clear', this.isClear);
        this.$refs.companyFrom.clearValidate('majorCategory')
      })
    },
    method_getFormData() {
     return new Promise((resolve, reject)=> {
        this.$refs.companyFrom.validate((valid) => {
          if(valid) {
            // 多个视频上传，请不要去掉
            // let video = (this.self_form.video || []).filter(item => {
            //   return item.originUrl
            // })
            resolve({...this.self_form, video: this.actualVideo})
          } else {
            resolve(false)
          }
      })
     })
    },
    async getAddressList(){
        let res = await queryAddress();
        if(res.result === 1){
          this.addressList = res.data || []
        }
    },
    method_reset() {
      this.self_form.video = [];
      this.$refs.companyFrom.resetFields()
    },
    openEditRefundAddress(){
        this.$router.push({
          path: '/supplier/base/address'
        })
        // this.$refs.editRefundAddressDialog.method_open()
    },
  }
  
}
</script>

<style lang="scss" scoped>
.main-categories {
    display: inline-block;
    width: 80%;
    min-height: 88px;
    padding: 5px 10px;
    color: #333;
    background-color: #FFF;
    border: 1px solid #DCDFE6;
    border-radius: 2px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1)
  }
  // .tips{
  //   color: #999999;
  // }
  .num {
    margin-right: 20px;
    font-weight: bold;
  }
  .main-platform {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .platform-item {
      display: flex;
      align-items: center;
      .num{
        display: inline-block;
        padding-left: 10px;
      }
    }
  }
  .mar-r{
    margin-right: 10px;
    margin-bottom: 10px;
  }

.tip-icon {
  font-size: 16px;
  margin-left: 3px;
}
</style>